import { useObjectCategoryDrawerStore } from "store/configuration.store"
import { ObjectCategoryInfo } from "./layout/ObjectCategoryInfo/ObjectCategoryInfo"
import { Drawer } from "components/ui/drawer/Drawer"
import { ModelNumbers } from "./layout/ModelNumbers/ModelNumbers"
import { CompositeCategories } from "./layout/CompositeCategories/CompositeCategories"
import style from "./ObjectCategoryDrawer.module.scss"

const { objectCategoryDrawer, infoWrapper, compositeCategoriesWrapper } = style

export const ObjectCategoryDrawer = () => {
	const { isDrawerOpen, triggerDrawer, objectCategoryStore } = useObjectCategoryDrawerStore()

	return (
		<Drawer
			styles={{
				body: { backgroundColor: "var(--clr-superLightGray)", padding: 0 },
				content: { borderRadius: "16px", margin: "8px 0" },
			}}
			open={isDrawerOpen}
			onClose={() => triggerDrawer()}
			width={992}
		>
			<div className={objectCategoryDrawer}>
				<div className={infoWrapper}>
					<ObjectCategoryInfo />
				</div>
				{/* Show composite categories component if object type is composite_object */}
				{objectCategoryStore.type === "composite_object" ? (
					<div className={compositeCategoriesWrapper}>
						<CompositeCategories />
					</div>
				) : null}
				<ModelNumbers />
			</div>
		</Drawer>
	)
}
